import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useTitle } from '@core/utils';

import { BranchInspectionsPage, BranchInspectionScanPage } from '../pages';

const BranchInspectionsRouter: FC = () => {
  useTitle('Filial yoxlanışları');

  return (
    <Route>
      <Switch>
        <Route exact path='/@next/branch-inspections' component={BranchInspectionsPage} />
        <Route path='/@next/branch-inspections/:id/scan' component={BranchInspectionScanPage} />
      </Switch>
    </Route>
  );
};

export default BranchInspectionsRouter;
